import { createApi } from "@reduxjs/toolkit/query/react";
import { State } from "@shared/models/State";
import { Neighborhood } from "@shared/models/Neighborhood";
import { ZipCode } from "@shared/models/ZipCode";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../config";

export type GetCountyListResponse = {
  items: State[];
  total: number;
};

export type GetCountyListParams = {
  state_id?: number;
  order?: string;
  direction?: string;
};

export type GetZipCodeListResponse = {
  items: ZipCode[];
  total: number;
};

export type GetZipCodeListParams = {
  county_id?: number;
};

export type GetNeighborhoodListResponse = Neighborhood[];

export type GetNeighborhoodListParams = {
  county_id?: number;
};

export const countyApi = createApi({
  reducerPath: "countyApi",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseApiUrl,
  }),
  tagTypes: ["CountyList", "County", "ZipCodeList", "NeighborhoodList"],
  endpoints: (builder) => ({
    getCountyList: builder.query<GetCountyListResponse, GetCountyListParams>({
      query: (params) => {
        return {
          url: "counties",
          params,
        };
      },
      providesTags: ["CountyList"],
    }),
    getZipCodeList: builder.query<GetZipCodeListResponse, GetZipCodeListParams>({
      query: (params) => {
        return {
          url: "counties/zips",
          params,
        };
      },
      providesTags: ["ZipCodeList"],
    }),
    getNeighborhoodList: builder.query<GetNeighborhoodListResponse, GetNeighborhoodListParams>({
      query: (params) => {
        return {
          url: "counties/neighborhoods",
          params,
        };
      },
      providesTags: ["NeighborhoodList"],
    }),
  }),
});

export const { useGetCountyListQuery, useGetZipCodeListQuery, useGetNeighborhoodListQuery } = countyApi;
